module.exports = __webpack_public_path__ + "static/img/major_service_graduate2.2f1e4d2b.jpg";